import { useMemo } from 'react'
import type { CurecallGroupedMultiSelectGroup, CurecallMultiSelectItem } from '@honestica/curecall-ui'
import { useCurrentProject } from 'src/providers/current-project.provider'

export const useMedEventFilterOptions = () => {
  const { followups, getMedEventLabelById } = useCurrentProject()

  const medEventGroups = useMemo<CurecallGroupedMultiSelectGroup[]>(
    () =>
      followups
        .filter((followup) => (followup.configUI?.medEventsUI?.length ?? 0) > 0)
        .map((followup) => ({
          label: followup.name,
          value: followup.id,
          children: followup.configUI.medEventsUI.map((medEventUI) => ({
            value: medEventUI.MedEvent.id,
            label: getMedEventLabelById(medEventUI.MedEvent.id),
          })),
        })),
    [followups, getMedEventLabelById],
  )

  const allMedEventItems = useMemo<CurecallMultiSelectItem<number>[]>(
    () => medEventGroups.flatMap((group) => group.children),
    [medEventGroups],
  )

  return { medEventGroups, allMedEventItems }
}
